import React from "react";
import {FiRefreshCcw} from "react-icons/fi";
import {FaMapMarkerAlt} from "react-icons/fa";
import {MdHourglassEmpty} from "react-icons/md";
import CrowdedLinearGraph from "./CrowdedLinearGraph";
import {IPeopleCountMarker} from "../../../constants/list/PeopleCountMarkerList";
import {StringUtils} from "anuro-platform-core";

interface Props {
  item: IPeopleCountMarker;
  openCrowdedStepGuideModal: () => void;
}
interface State {}

export default class PlaceFloatingPopulation extends React.Component<Props, State> {
  render() {
    const {item} = this.props;
    return (
      <div className={"place-info-container"}>
        <div className={"place-info"}>
          <div className={"row"} style={{display: "flex", alignItems: "center"}}>
            <div className={"txt"} style={{fontSize: 16}}>상세주소</div>
            <FiRefreshCcw color={"#FFFFFF"} size={30} style={{cursor: "pointer"}}/>
          </div>

          <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
            <FaMapMarkerAlt color={"#999999"} fontSize={12}/>
            <div style={{color: "#999999", fontSize: 13, marginLeft: 5}}>{item.address}</div>
          </div>

          <div style={{height: 10}}/>

          <div className={"row"}>
            <div style={{flex: 1}}>
              <img alt={"건물 사진"} src={item.image} style={{borderRadius: 10, maxWidth: 260, maxHeight: 160, width: "100%"}}/>
            </div>
            <div style={{width: 12}}/>
            <div className={"card-container"}>
              <div className={"txt card-title"}>
                실내 총 인원 수
              </div>
              <div style={{height: 12}}/>
              <div className={"txt"} style={{fontSize: 20, textAlign: "center"}}>
                총 <span style={{fontSize: 28}}>{StringUtils.numberWithCommas(item.peopleCount)}</span> 명
              </div>
              <div style={{height: 10}}/>
              <span className={"txt"} style={{fontSize: 13, textAlign: "center", borderBottom: "1px solid #333", paddingBottom: 10}}>
                  인구 혼잡도 <span style={{fontSize: 17, color: "#FF0000"}}>심각</span> 단계
                </span>
              <div style={{height: 18}}/>
              <div className={'txt'} style={{alignItems: "center", justifyContent: "center", display: "flex"}}>
                <MdHourglassEmpty  color={"#50C9C3"} />
                <span style={{fontSize: 12}}>최근 동작 감지 시간: <span style={{fontSize: 11, color: "#FFFFFF90"}}>18h : 17m : 20s</span></span>
              </div>
            </div>
          </div>
          <div style={{ height: 30 }}/>

          <CrowdedLinearGraph openCrowdedStepGuideModal={this.props.openCrowdedStepGuideModal}/>
        </div>
      </div>
    );
  }
}
